import api from './api';

export interface ArticleSeries {
  _id: string;
  title: string;
  slug: string;
  description?: string;
  coverImage?: string;
  createdBy?: { _id: string; name: string; profileImage?: string };
  isActive: boolean;
  articleCount: number;
  createdAt: string;
  updatedAt: string;
}

export interface SeriesListResponse {
  docs: ArticleSeries[];
  totalDocs: number;
  limit: number;
  page: number;
  totalPages: number;
  hasNextPage: boolean;
  hasPrevPage: boolean;
}

/** لیست مجموعه‌ها (ادمین) */
export const getSeries = async (
  page = 1,
  limit = 20,
  search?: string,
  activeOnly?: boolean
): Promise<SeriesListResponse> => {
  const params: any = { page, limit };
  if (search) params.search = search;
  if (activeOnly) params.activeOnly = 'true';
  const res = await api.get('/admin/articles/series', { params }) as any;
  return res.data?.data || res.data;
};

/** جزئیات مجموعه */
export const getSeriesById = async (id: string) => {
  const res = await api.get(`/admin/articles/series/${id}`) as any;
  return res.data?.data || res.data;
};

/** ایجاد مجموعه */
export const createSeries = async (data: {
  title: string;
  description?: string;
  coverImage?: string;
}) => {
  const res = await api.post('/admin/articles/series', data) as any;
  return res.data?.data || res.data;
};

/** ویرایش مجموعه */
export const updateSeries = async (
  id: string,
  data: { title?: string; description?: string; coverImage?: string; isActive?: boolean }
) => {
  const res = await api.put(`/admin/articles/series/${id}`, data) as any;
  return res.data?.data || res.data;
};

/** حذف مجموعه */
export const deleteSeries = async (id: string) => {
  const res = await api.delete(`/admin/articles/series/${id}`) as any;
  return res.data;
};
